export default __webpack_public_path__ + "static/whatsappIcon-48c3929dce819848894656e1ede29768.svg";